import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter, Router } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import { store, persistor } from './store';
import GlobalStyle from './components/GlobalStyle';

import Routes from './routes';
import history from './services/history';
import HttpsRedirect from '~/components/_layout/HttpsRedirect';

import './assets/css/app.css';

import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <HttpsRedirect>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Router history={history}>
              <GlobalStyle />
              <Routes />
              <ToastContainer autoClose={3000} bodyClassName="f14" />
            </Router>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </HttpsRedirect>
  );
}

export default App;
